import { AlertTriangle } from "lucide-react";
import { SideSheet, Button } from "@/components/ui";
import { useTranslation } from "@/packages/utils";

type DestructiveActionType = "remove_from_audit";

interface DestructiveConfirmSheetProps {
  open: boolean;
  onClose: () => void;
  action: DestructiveActionType | null;
  itemTitle: string;
  onConfirm: () => void;
}

export function DestructiveConfirmSheet({
  open,
  onClose,
  action,
  itemTitle,
  onConfirm,
}: DestructiveConfirmSheetProps) {
  const { t } = useTranslation(["audits", "common"]);

  if (!action) return null;

  return (
    <SideSheet open={open} onClose={onClose}>
      <div className="flex flex-col h-full">
        <div className="flex-1 flex flex-col items-center justify-center px-8 py-12 text-center">
          <div
            className="flex h-14 w-14 items-center justify-center rounded-full mb-5"
            style={{ backgroundColor: "rgba(232,115,74,0.12)" }}
          >
            <AlertTriangle size={28} className="text-accent" />
          </div>

          <h3 className="text-lg font-semibold text-primary mb-2">
            {t("checklist.destructiveConfirm.title")}
          </h3>

          <p className="text-sm text-secondary mb-4 max-w-[320px]">
            {t("checklist.destructiveConfirm.description")}
          </p>

          <div className="rounded-lg bg-card border border-border px-4 py-3 w-full max-w-[320px]">
            <p className="text-xs text-muted mb-1">
              {t("checklist.destructiveConfirm.affectedItem")}
            </p>
            <p className="text-sm font-medium text-primary truncate">
              {itemTitle}
            </p>
          </div>
        </div>

        <div className="shrink-0 border-t border-border px-6 py-4">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="md"
              onClick={onClose}
              className="flex-1"
            >
              {t("common:buttons.cancel")}
            </Button>
            <Button variant="primary" onClick={onConfirm} className="flex-1">
              {t("checklist.destructiveConfirm.removeItem")}
            </Button>
          </div>
        </div>
      </div>
    </SideSheet>
  );
}
